//权限控制
import router from '@/router'
import utils from '../business-common'
// import NProgress from 'nprogress' // Progress 进度条
// import 'nprogress/nprogress.css' // Progress 进度条样式
export function permission() {
  router.beforeEach((to, from, next) => {
    console.log(to)
    if(to.path == '/sale/payResult1'||to.path == '/originLink'){
      next()
    }else{
      if (to.query.token) {
        utils.setCookie('token', to.query.token, 1)
        localStorage.setItem('token', to.query.token)
      }
      if(!to.query.isSingle &&  window.localStorage.getItem('ctoken')){
        window.localStorage.clear()
        next({ path: '/login' })
      }
      // NProgress.start()
      //修改title
      const title = to.meta && to.meta.title
      if (title) {
        document.title = title
      }
      //判断是否登录
      let cookieToken = utils.getCookie('token')
      let localToken = localStorage.token
      if (!cookieToken || !localToken) {
        localStorage.token = ''
        utils.delCookie('token')
        //无token，判断是否需要登录
        if (to.meta.auth) {
          if (window.WebViewJavascriptBridge) {
            EWebBridge.webCallAppInJs('bridge', { flag: 'login' })
          } else {
            if(JSON.stringify(to.query)!="{}"){
              let thisPath = `/login?redirect=${to.path}`
              for(let key in to.query){
                thisPath += '?'+key+'='+to.query[key]
              }
              // next(`/login?redirect=${to.path}`)
              next(thisPath)
            }else{
              next(`/login?redirect=${to.path}`)
            }
            
          }
        } else {
          next()
        }
      } else {
        if (to.path == '/login') {
          next()
        } else if (to.path == '/') {
          next({ path: '/home' })
        } else {
          next()
        }
      }
    }
    
  })
  // 结束Progress
  router.afterEach(() => {
    // NProgress.done()
  })
}
